module.exports = __webpack_public_path__ + "static/img/18.889505e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/18.png
// module id = 8ved
// module chunks = 1